module.exports = __webpack_public_path__ + "img/nissan_thumbnail.3754f5d3.png";